import React from 'react';
import { View, Text, TextInput, StyleSheet } from 'react-native';

interface SerialNumberInputProps {
  value: string;
}

const SerialNumberInput: React.FC<SerialNumberInputProps> = ({ value }) => (
  <View style={styles.wrapper}>
    <Text style={styles.label}>Serial Number</Text>
    <TextInput
      style={styles.input}
      value={value}
      editable={false}
      autoComplete='off'
      autoCorrect={false}
    />
  </View>
);

const styles = StyleSheet.create({
  wrapper: { 
    marginBottom: 16 
  },
  label: { 
    color: '#fff', 
    marginBottom: 4, 
    fontWeight: '600' 
  },
  input: { 
    backgroundColor: '#292D33', 
    color: '#fff', 
    padding: 12, 
    borderRadius: 24, 
    opacity: 0.6 
  },
});

export default SerialNumberInput;